import React from 'react';
import { useIntl } from 'react-intl';
import { getFormattedDate } from '../../utils/date';
export default function LeaderboardHeader(_a) {
    var data = _a.data;
    var intl = useIntl();
    var getDate = function () {
        var _a;
        if (data === null || data === void 0 ? void 0 : data.date) {
            return getFormattedDate(data.date, (_a = data.units) !== null && _a !== void 0 ? _a : 'metric', data.timezone);
        }
        return '';
    };
    return (React.createElement("div", { className: "header" },
        React.createElement("h3", { className: "header-title" }, data === null || data === void 0 ? void 0 : data.gameName),
        React.createElement("div", { className: "header-info" },
            React.createElement("div", { className: "header-info-course" }, data && (React.createElement(React.Fragment, null,
                React.createElement("span", null, data.clubName),
                " | ",
                React.createElement("span", null, data.courseName),
                " |",
                ' ',
                React.createElement("span", null,
                    intl.formatMessage({ id: 'leaderboard.par' }),
                    " ",
                    data.par)))),
            React.createElement("div", { className: "header-info-date" }, getDate()))));
}
